<template>
  <div class="strabrkdwn std_cont">
    <div
      v-show="!isPreflop"
      class="strabrkdwn_bottom strabrkdwn_item"
    >
      <StudyAllHandsHero
        class="flex-1"
        style="--radius: 4px"
        :useHex="useHex"
        :customCombos="isPreflop ? [] : combos"
        :viewProps="viewProps"
        :studyFilter="filterCombos"
        :isPinned="!!heroGroupId"
        :activeHandsIds="heroHandsIds"
        :hasLegend="true"
        @combo:click="h => $store.dispatch('sol_detail_click_hand', { hand: h, tableGroups })"
        @combo:mouseenter="h => $store.dispatch('sol_detail_hover_hand', { hand: h, tableGroups })"
        @combo:mouseleave="$store.dispatch('sol_detail_hover_hand'), handleAllHandsMouseleave()"
        @allhands:mouseenter="handleAllHandsMouseenter()"
      >
      </StudyAllHandsHero>
    </div>
    <div class="strabrkdwn_top strabrkdwn_item flex-1">
      <BreakdownTableV2
        class="data-table_bt_0 data-table_inside-overflow"
        :customCombos="combos"
        :namespace="namespace"
        :canAISolve="canAISolve"
        :activeHandsIds="heroHandsIds"
        :solution="solution_picked"
        :hero="hero"
        :useHex="useHex"
        :grouping="grouping"
        :isPinned="!!heroGroupId"
        :showBetsIn="showBetsIn"
        :filterCombos="filterCombos"
        :rangeKey="viewProps.rangeKey"
        :catDraws="catDraws"
        :catHands="catHands"
        :catEqBuckets="catEqBuckets"
        :catEqBucketsAdvanced="catEqBucketsAdvanced"
        :actionHighlighted="actionHighlighted"
        :viewProps="viewProps"
        @combo:click="h => $store.dispatch('sol_detail_click_hand', { hand: h, tableGroups })"
        @combo:mouseenter="h => $store.dispatch('sol_detail_hover_hand', { hand: h, tableGroups })"
        @combo:mouseleave="$store.dispatch('sol_detail_hover_hand'), handleAllHandsMouseleave()"
        @allhands:mouseenter="handleAllHandsMouseenter()"
      >
        <template #message>
          <MessageOverlaySkeleton
            v-if="!showFlopContent"
            class="gw_mesblock_container"
            :isBlurred="true"
            :isTopDown="true"
            style="
              position: relative;
              padding: 2rem 0;
              --content-margin: auto auto auto auto;
              --radius: 0 0 4px 4px;
              --back-from: var(--clr-black-0);
              --back-to: var(--clr-black-0);
            "
          >
            <MessagesGoPostflop
              :namespace="namespace"
              :canAISolve="canAISolve"
              :posflopContent="$t('tabs.breakdown')"
            >
            </MessagesGoPostflop>
          </MessageOverlaySkeleton>
        </template>
      </BreakdownTableV2>
    </div>
  </div>
</template>

<script>
import MessagesGoPostflop from '@/components/Poker/Overlays/Messages/MessagesGoPostflop'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import BreakdownTableV2 from '@/components/DataTables/v2/tables/BreakdownTableV2/BreakdownTableV2'
import StudyAllHandsHero from '@/components/Study/StudyAllHandsHero'

export default {
  name: 'StudyRangesBreakdown',

  components: {
    BreakdownTableV2,
    StudyAllHandsHero,
    MessagesGoPostflop,
    MessageOverlaySkeleton,
  },
  props: {
    namespace: { required: true, type: String },
    canAISolve: { required: true, type: Boolean },
    actionHighlighted: Object,
    asideTabKey: { default: () => 'sw_tabs_handmatrix' },
    catDraws: Array,
    catEqBuckets: Array,
    catEqBucketsAdvanced: Array,
    catHands: Array,
    combos: { default: () => [] },
    filterCombos: Object,
    grouping: String,
    hero: Object,
    heroGroupId: String,
    heroHandsIds: { default: () => [] },
    isPreflop: Boolean,
    mobile: Boolean,
    showBetsIn: String,
    showFlopContent: Boolean,
    solution_picked: { default: () => [] },
    tableGroups: { default: () => [] },
    useHex: Boolean,
    viewProps: Object,
  },
  data() {
    return {
      lastTab: '',
    }
  },
  methods: {
    handleAllHandsMouseenter() {
      if (this.mobile) return
      if (this.heroGroupId) return
      this.lastTab = this.$store.getters[this.asideTabKey]
      if (this.lastTab === 'filters') {
        this.$store.dispatch('switchers_set_item_by_value', {
          key: this.asideTabKey,
          value: 'hands',
        })
      }
    },
    handleAllHandsMouseleave() {
      if (this.mobile) return
      if (this.lastTab === 'filters') {
        if (this.heroGroupId) return
        this.$store.dispatch('switchers_set_item_by_value', {
          key: this.asideTabKey,
          value: 'filters',
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.strabrkdwn {
  --gap: var(--laytsttd-gap, 0.5rem);
  gap: var(--gap);

  flex-direction: column;
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  &_top {
    display: flex;
    min-height: 0;
    min-width: 0;
    overflow: auto;
  }
  &_item {
    padding: var(--laytsttd-padding-content);
    background: var(--clr-black-1);
    border-radius: 6px;
    position: relative;
    &_bottom {
      display: flex;
      flex: 1;
    }
  }
}
</style>
